import classNames from 'classnames';
import { MouseEvent } from 'react';
import TrailMetadataStats from '@alltrails/cards/components/TrailMetadataStats';
import usePublicBaseUrl from '@alltrails/context/hooks/usePublicBaseUrl';
import { useLanguageRegionCode } from '@alltrails/core/hooks/useLanguageRegionCode';
import TableRow from '@alltrails/denali/components/TableRow';
import type { TrailSearchResult } from '@alltrails/types/AlgoliaResults';
import { getLocation, getUrl } from '../../utils/algoliaResultUtils';
import getBoldedTextElements from '../../utils/getBoldedTextElements';
import ResultIcon from './ResultIcon';
import styles from './styles/styles.module.scss';

const onLinkClick = (event: MouseEvent<HTMLAnchorElement>) => {
  event.preventDefault();
};

export type TrailResultContentProps = {
  query: string;
  trail: TrailSearchResult;
};

const TrailResultContent = ({ query, trail }: TrailResultContentProps) => {
  const baseUrl = usePublicBaseUrl();
  const languageRegionCode = useLanguageRegionCode();

  const label = getBoldedTextElements(trail.name, query);
  const description = getBoldedTextElements(getLocation(trail, true) || '', query);

  const icon = (
    <div className={styles.iconContainer}>
      <ResultIcon result={trail} />
    </div>
  );

  const content = (
    <TableRow
      className={classNames(styles.listItemContent, styles.alignCenter)}
      leftContent={icon}
      label={<div className={styles.label}>{label}</div>}
      description={
        <>
          {description && <div className={styles.truncate}>{description}</div>}
          <TrailMetadataStats
            avgRating={trail.avg_rating}
            compact
            difficulty={Number(trail.difficulty_rating)}
            durationMinutes={trail.duration_minutes}
            isDurationMinutesEstimate
            durationText={trail.estimated_time_to_complete_text}
            lengthText={trail.length_text}
            lengthMeters={trail.length}
            reviewCount={trail.num_reviews}
            size="sm"
          />
        </>
      }
      testId={`algolia-search-${trail.name}`}
    />
  );

  // The url is just to get link niceties like "open in new tab" behavior - normal navigation must be handled by the onSelect
  return (
    <a href={`${baseUrl}${getUrl(trail, languageRegionCode, true)}`} tabIndex={-1} onClick={onLinkClick}>
      {content}
    </a>
  );
};

export default TrailResultContent;
